import React from 'react';
import { Link } from 'react-router-dom';

function PageHero({ title, sub }) {
  return (
    <div className="page-hero">
      <div className="page-hero-bg"/>
      <div className="container">
        <span className="section-tag">Meet the Experts</span>
        <h1 className="page-hero-title">{title}</h1>
        <p className="page-hero-sub">{sub}</p>
      </div>
    </div>
  );
}

const doctors = [
  {
    init:'Dr. SA', name:'Dr. Sangeeta Arvind', role:'Oral Surgeon, Implantologist, Cleft Specialist',
    qual:'BDS, MDS (Oral Surgery)',
    exp:'Lead Doctor',
    bio:'The visiting card identifies Dr. Sangeeta Arvind as BDS, MDS (Oral Surgery), an implantologist with training listed from Sawangi, Wardha, and a cleft specialist with training listed from Raipur.',
    tags:['Oral Surgery','Implantology','Cleft Care'],
    grad:'135deg, #F4A200, #E8610C',
  },
];

export default function Team() {
  return (
    <>
      <PageHero title={<>Meet the <em>Clinic Doctor</em></>} sub="The verified doctor information currently available for the site is for Dr. Sangeeta Arvind." />

      <section className="section">
        <div className="container">
          <div className="team-detail-grid">
            {doctors.map((d, i) => (
              <div key={i} className="doctor-card reveal" style={{'--delay': `${(i % 2) * 0.12}s`}}>
                <div className="dc-avatar-wrap">
                  <div className="dc-avatar" style={{background:`linear-gradient(${d.grad})`}}>{d.init}</div>
                  <div className="dc-exp-badge">{d.exp}</div>
                </div>
                <div className="dc-info">
                  <span className="dc-role">{d.role}</span>
                  <h2 className="dc-name">{d.name}</h2>
                  <span className="dc-qual">{d.qual}</span>
                  <p className="dc-bio">{d.bio}</p>
                  <div className="dc-tags">{d.tags.map(t => <span key={t} className="dc-tag">{t}</span>)}</div>
                  <Link to="/contact" className="btn-primary">Book with {d.name.split(' ')[0]} {d.name.split(' ')[1]} →</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Accreditations */}
      <section className="section" style={{paddingTop:0}}>
        <div className="container">
          <div className="accred-strip reveal">
            <h3>Our Accreditations & Memberships</h3>
            <div className="accred-list">
              {['BDS','MDS (Oral Surgery)','Implantologist (Sawangi, Wardha)','Cleft Specialist (Raipur)','Dant Sanjeevani - Maxillofacial & Cleft Clinic'].map(a => (
                <div key={a} className="accred-item">
                  <span className="accred-dot">✦</span>{a}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
